<mat-toolbar id="nv-container" *ngIf="routeFlag">
    <ul id="nv-drpdwn" class="nav-container">
        <li>
            <a id="nav-dashboard" routerLinkActive="active" routerLink="/dashboard"
            >Dashboard</a
            >
        </li>
        <ng-container *ngIf="canViewAssetManagement$ | async">
            <li>
                <a
                        id="nav-asset-administration"
                        routerLinkActive="active"
                        routerLink="/asset-administration"
                >Asset Administration</a
                >
            </li>
        </ng-container>
        <ng-container>
            <li *ngIf="canViewUserManagement$ | async">
                <a
                        id="nav-user-management"
                        routerLinkActive="active"
                        routerLink="/user-management">
                    User Management
                </a>
            </li>
        </ng-container>
        <li *ngIf="canViewReports$ | async">
            <a id="nav-reports" routerLinkActive="active" routerLink="/reports"
            >Report & Export</a
            >
        </li>
        <ng-container *ngIf="isSubRegionManagementEnabled$ | async">
            <li *ngIf="canViewRegionManagement$ | async">
                <a id="nav-region-management" routerLinkActive="active" routerLink="/region-management">Region Management</a>
            </li>
        </ng-container>
        <ng-container *ngIf="isConfigTabEnabled$ | async">
            <li>
                <a id="nav-config" routerLinkActive="active" routerLink="/config">Config</a>
            </li>
        </ng-container>
        <ng-container *ngIf="isEnterprisesTabEnabled$ | async">
            <li>
                <a id="nav-enterprises" routerLinkActive="active" routerLink="/enterprises">Enterprises</a>
            </li>
        </ng-container>
    </ul>
    <span class="nav-spacer"></span>
    <span class="lng-services"> Language: EN </span>
</mat-toolbar>
